import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { getDistributions } from 'store/actions';

const initialState = {
    distributionTree: [],
    distributions: {},
    activeDistribution: null,
    order: [],
    error: null,
    loading: false
};

const getDistributionTreeStart = (state, action) => {
    return updateObject( state, { error: null, loading: true } );
}

const getDistributionTreeFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        loading: false
    });
}

// function wrap child distributions into children of distribution
const getDistributionChildren = (level) => {
    // init children object
    let children = [];
    // init length counter
    let length = 0;
    // check if level has children
    if (level.children.length > 0) {
        // process children
        level.children.forEach((item, index) => {
            // init item
            let _item = item.project;
            // update object with metadata
            updateObject(_item, item.project.data.metadata.fields);
            // set created (for sorting)
            _item['created'] = item.project.metadata.fields.created;
            _item['isChild'] = true;
            // append distribution
            children[length] = _item;
            children[length]['name'] = item.project.name;
            children[length]['children'] = getDistributionChildren(item);
            // increment length
            length ++;
        });
    }

    // return child tree
    return children;
};

const getDistributionTreeSuccess = (state, action) => {
    
    // init distribution tree
    let distributionTree= [];
    // init length counter
    let length = 0;
    // process first level
    action.children.forEach((item, index) => {
        // init item
        let _item = item.project;
        // update object with metadata
        updateObject(_item, item.project.data.metadata.fields);
        // set created (for sorting)
        _item['created'] = item.project.metadata.fields.created;
        _item['isChild'] = false;
        // append distribution
        distributionTree[length] = _item;
        distributionTree[length]['name'] = item.project.name;
        distributionTree[length]['children'] = getDistributionChildren(item);
        // increment length
        length ++;
    });

    // init flat list of distributions
    let distributions = {};
    // function to flatten distribution tree
    const flattenTree = function(children) {
        // loop through children
        children.forEach((item, index) => {
            // init item
            let _item = {};
            // set data
            _item = item.data;
            // set meta
            updateObject(_item, item.data.metadata.fields);
            // set created
            _item['created'] = item.created;
            // store in flat list
            distributions[item.data.id] = _item;
            // check for childs
            if(item.children.length > 0) {
                // append children
                flattenTree(item.children);
            }
        });
    };
    // execute flatten function
    flattenTree(distributionTree);

    return updateObject(state, {
        distributionTree: distributionTree,
        distributions: distributions,
        loading: false
    });
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_DISTRIBUTION_TREE_START: return getDistributionTreeStart(state, action);
        case actionTypes.GET_DISTRIBUTION_TREE_SUCCESS: return getDistributionTreeSuccess(state, action);
        case actionTypes.GET_DISTRIBUTION_TREE_FAIL: return getDistributionTreeFail(state, action);
        default: 
            return state;
    }
}

export default reducer;
